import { initErrorLogger } from 'scripts/errorLogger';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import featuresApi from 'api/requests/features';
import { GoogleOAuthProvider } from '@react-oauth/google'; // Importação correta

// Vite exposes env vars as strings, so `VITE_FEATURE_FLAG_ENABLED=false` is a
// non-empty string and therefore truthy — compare against 'true' explicitly.
window.featuresFlagEnabled = import.meta.env.VITE_FEATURE_FLAG_ENABLED === 'true'
window.features = []

async function getFeaturesFlags() {
  try {
    const { data } = await featuresApi.flags()
    const enabledFeatures = data.data.filter(el => el.enabled)

    enabledFeatures.map(el => {
      window.features = [...window.features, el.name]
    })
  } catch (error) {
    window.features = []
  }
}

// A promise any consumer can await to know the flags have actually finished
// loading, instead of reading `window.features` as a bare, non-reactive
// snapshot that may still be empty. Resolves immediately when the flag
// system itself is disabled.
window.featuresReady = window.featuresFlagEnabled ? getFeaturesFlags() : Promise.resolve()

initErrorLogger();

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();